var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsDateString, IsOptional } from "class-validator";
import { safeAssign } from "./safe-assign";
export class GetRevenueIssuesParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetRevenueIssuesParams.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetRevenueIssuesParams.prototype, "to", void 0);
export class GetEmployeeIssuesParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEmployeeIssuesParams.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEmployeeIssuesParams.prototype, "to", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetEmployeeIssuesParams.prototype, "includeIgnored", void 0);
export class GetShiftIssuesParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetShiftIssuesParams.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetShiftIssuesParams.prototype, "to", void 0);
__decorate([
    Expose(),
    IsArray(),
    __metadata("design:type", Array)
], GetShiftIssuesParams.prototype, "filters", void 0);
export class ShiftIssueDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ShiftIssueDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ShiftIssueDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ShiftIssueDTO.prototype, "details", void 0);
//# sourceMappingURL=issue.dto.js.map